import type { LogoState } from './cost-to-build-client-ui-logo.types';

export const LOGO_INITIAL_STATE: LogoState = {
    alt: 'La pièce en plus',
    src: '/logos/la-piece-en-plus.svg',
};

export const areLogoStatesEqual = (left: LogoState, right: LogoState): boolean =>
    left.alt === right.alt && left.src === right.src;
